import { useMemo } from 'react';
import { ResponseProductAttribute } from '@/data/types/Product';
import { ColumnText } from '@/components/content/HdmSkucomparer/parts/ColumnText';

export const ColumnAttribute = ({
	name,
	attributes,
	...props
}: {
	name: string;
	attributes: ResponseProductAttribute[] | undefined;
	isVisible?: boolean;
	isMainProduct?: boolean;
}) => {
	const value = useMemo(() => {
		const attribute = attributes
			?.find((a) => a.name.toLowerCase() === name.toLowerCase())
			?.values?.find((v) => v.value);

		if (!attribute) return null;

		if (Array.isArray(attribute.value)) return null;

		return attribute.value;
	}, [name, attributes]);

	return <ColumnText {...props} name={name} text={value} />;
};
